module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0f37a12bb543f7559536071b670ffc9e.png";